import { loadComponent } from '@/helpers/asyncLoaders'
import store from '@/store/store'

import {
  VUEX_USER_HAS_CONFERENCE_ASIAN,
  VUEX_USER_HAS_CONFERENCE_DOMESTIC,
  VUEX_USER_HAS_CONFERENCE_INTERNATIONAL
} from '@/store/constants/user'

const hasPerms = () => {
  return store.getters[VUEX_USER_HAS_CONFERENCE_ASIAN] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_DOMESTIC] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_INTERNATIONAL]
}

export const routes = {
  path: 'spring27',
  name: 'spring27--main',
  meta: {
    conferenceClass: 'spring27'
  },
  component: loadComponent('GlobalConference/Spring27/Main.vue'),
  redirect: { name: 'spring27--landing' },
  children: [
    {
      path: 'load',
      name: 'spring27--load',
      component: loadComponent('GlobalConference/Spring27/Pages/Load.vue')
    },
    {
      path: 'landing',
      name: 'spring27--landing',
      component: loadComponent('GlobalConference/Spring27/Pages/LandingNew.vue'),
      beforeEnter: (to, from, next) => {
        if (!store.state.globalConference.spring27.loaded) {
          return next({ name: 'spring27--load' })
        }
        next()
      }
    },
    {
      path: 'categories',
      name: 'spring27--categories',
      component: loadComponent('GlobalConference/Spring27/Pages/Categories.vue'),
      meta: {
        eventCategory: 'spring27',
        title: 'Product Categories',
        navigation: [
          'Womens',
          'Mens',
          'Kids',
          'Unisex'
        ]
      }
    },
    {
      path: 'ads',
      name: 'spring27--ads',
      component: loadComponent('GlobalConference/Spring27/Pages/AdvertisingNew.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPerms()) {
          next()
        } else {
          next('/')
        }
      },
      meta: {
        eventCategory: 'spring27',
        title: 'Advertising',
        navigation: [
          'Marketing',
          'Womens',
          'Mens',
          'Kids',
          'Unisex',
          'Work',
          'BTS',
          'International',
          'Performance',
          'Social',
          'Radio',
          'Apparel'
        ]
      }
    },
    {
      path: 'sessions',
      name: 'spring27--sessions',
      component: loadComponent('GlobalConference/Spring27/Pages/SessionsNew.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPerms()) {
          next()
        } else {
          next('/')
        }
      },
      meta: {
        eventCategory: 'spring27',
        title: 'General Sessions'
      }
    },
    {
      path: '',
      name: 'spring27--dashboard',
      redirect: { name: 'spring27--ads' }
    }
  ]
}
